export const statusClaimTest = (text: string) => /refund_|cancel_|change_/.test(text);
export const numberCheck = (text: string) => /^[0-9]*$/.test(text);
